import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import {SetValueOptions} from 'components/hook-form/helpers';
import React from 'react';
import {useController, useFormContext} from 'react-hook-form';
import {daysOfWeek} from 'types/DayOfWeek';

type DaysOfWeekFieldProps = {
   name: string;
   disabled?: boolean;
};

type Props = DaysOfWeekFieldProps & {
   value: any[];
   setValue: (value: any[]) => void;
};

const DaysOfWeekField = ({name, disabled, value, setValue}: Props) => {
   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const {name, checked} = event.target;
      if (checked) {
         return setValue([...value, name]);
      }
      setValue(value.filter((value) => name !== value));
   };
   return (
      <FormControl component="fieldset" disabled={disabled}>
         <FormGroup row>
            {daysOfWeek.options.map((day) => {
               const checked = value.includes(day.name);
               return (
                  <FormControlLabel
                     key={day.id}
                     label={day.id}
                     control={
                        <Checkbox
                           disableRipple
                           checked={checked}
                           onChange={handleChange}
                           name={day.name}
                        />
                     }
                  />
               );
            })}
         </FormGroup>
      </FormControl>
   );
};

const HookFormDaysOfWeekField = (props: DaysOfWeekFieldProps) => {
   const methods = useController({
      name: props.name,
   });

   const {
      field: {value},
   } = methods;
   const {setValue} = useFormContext();

   return (
      <DaysOfWeekField
         {...props}
         setValue={(val) => setValue(props.name, val, SetValueOptions)}
         value={value}
      />
   );
};

export default React.memo(HookFormDaysOfWeekField);
